import { authAxios } from "../api/axiosClient";
import { getLogDetail } from "../constants";


export const GetLogDetailCenter = (params = {}) => {
    const url = getLogDetail;
    return authAxios().get(url, { params });
};

